<template>
  <div class="w-full h-full app_carousel">
    <el-carousel
      class="carousel-icon h-full relative rounded-10px"
      :interval="data.speed * 1000"
      :autoplay="true"
      height="100%"
      arrow="never"
    >
      <el-carousel-item v-for="(item, index) in carouselArr" :key="index" class="cursor-pointer">
        <div class="w-full h-full" @click="toDetail(item)">
          <div class="w-full h-full flex items-center justify-center">
            <el-image
              v-if="item.imageFile"
              :src="`${fileUrl}${item.imageFile}`"
              :fit="data.imageFit || 'fill'"
              class="w-full h-full"
            ></el-image>
            <!-- <img :src="`${fileUrl}${item.imageFile}`" alt="" class="w-full h-full object-contain" /> -->
          </div>
          <div
            class="w-full h-45px text-18px pt-7px px-10px bg-hex-000 bg-opacity-50 text-center truncate absolute bottom-0 text-hex-fff"
            :title="item.title"
            :v-if="data.showTitle"
          >
            <div class="truncate">
              {{ item.title }}
            </div>
          </div>
        </div>
      </el-carousel-item>
      <div class="absolute bottom-50 left-0 z-10 customize">
        <!-- <button>customize</button> -->
      </div>
    </el-carousel>
  </div>
</template>
<script>
import { ColumnTableApi, ColumApi } from '@wiz-api/workbench'
import addRequestQueue from '@/assets/js/RequestQueue'

const columnTableApi = new ColumnTableApi()
const columApi = new ColumApi()
export default {
  name: 'carousel',
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      },
    },
    mode: {
      type: String,
      default: '',
    },
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(val) {
        if (!_.isEmpty(val) && !_.isEmpty(val.dataSource)) {
          this.getCompentsData(val.dataSource, val.pageSize)
        }
      },
    },
  },
  data() {
    return {
      carouselArr: [],
    }
  },
  methods: {
    async toDetail(row) {
      if (this.mode === 'update') {
        return
      }
      if (row.jumpType === 2) {
        row.skipMode === 1 ? window.open(row.url) : (window.location.href = row.url)
      } else if (row.jumpType === 1) {
        const path = `/portal/homepage?columnId=${row.jumpColumn}`
        row.skipMode === 1
          ? window.open(`${window.location.origin}${window.location.hash ? '/#' : ''}${path}`)
          : this.$router.push(path)
      }
    },
    async getCompentsData(id, pageSize) {
      const param = {
        columnId: id,
        isShow: true,
      }
      const [err, res] = await addRequestQueue(() => {
        return columnTableApi.getBinnerColumnTable(1, pageSize, param)
      })
      if (!err && res) {
        this.carouselArr = []
        _.map(res.items, (it) => {
          it.isShow === true ? this.carouselArr.push(it) : ''
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.carousel-icon {
  &:hover {
    .customize {
      display: block;
    }
  }
  .customize {
    display: none;
  }
  ::v-deep .el-carousel__button {
    height: 3px;
    width: 3px;
    border-radius: 100%;
    background: #fff;
  }
  ::v-deep .is-active {
    .el-carousel__button {
      width: 10px;
      border-radius: 3px;
      background-color: var(--portalPrimaryColor);
    }
  }
}
</style>
